import { Record } from 'immutable';
const TransientReservationSearchParametersRecord = Record({
  eventId: null,
  eventPartyId: null,
  firstName: null,
  lastName: null,
  minCheckInDate: null,
  maxCheckOutDate: null,
  ratePlanCode: null,
  confirmation: null
});

export class TransientReservationSearchParameters extends TransientReservationSearchParametersRecord {
  eventId: number;
  eventPartyId: number;
  firstName: string;
  lastName: string;
  minCheckInDate: string;
  maxCheckOutDate: string;
  ratePlanCode: string;
  confirmation: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/transient-reservation-search-params.ts